import { Link } from 'react-router-dom';
import { OpenInNew } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

import { resourceDetailPath } from '../utils/resource-routes';
import { IdChip } from './org-page-redesign/primitives';

/**
 * Copyable id chip with an "open in resource explorer" affordance.
 *
 * The link renders only when the organization is known: resources are always
 * org-scoped, so an org-less link had no valid target — it previously built
 * `?organization_id=` with an empty value, which the detail route could not
 * scope. Without an org the id is still shown and copyable, just not linked.
 */
export function ExplorableId({
  label,
  value,
  resourceType,
  organizationId,
}: {
  label: string;
  value: string;
  resourceType?: string;
  organizationId?: string | null;
}) {
  return (
    <span className="inline-flex items-center gap-1">
      <IdChip label={label} value={value} />
      {resourceType && organizationId && (
        <Tooltip title="Open in resource explorer">
          <IconButton
            size="small"
            component={Link}
            to={resourceDetailPath({ organizationId }, resourceType, value)}
          >
            <OpenInNew fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
    </span>
  );
}
